import {EntityModel} from "@fedeltapointofsale/data-client";
import {ITEM_TYPE, ScreenLayoutData, TouchItemData} from "./screen-layout.data";
import {Injectable, Injector} from "@angular/core";
import {SellableIconService} from "../../catalogue/sellable/sellable-icon.service";
import {SellableReferenceData} from "../../catalogue/sellable/sellable.data";

@Injectable()
export class ScreenLayoutEntityModel extends EntityModel<ScreenLayoutData> {
    constructor(injector: Injector, private sellableIconService: SellableIconService) {
        super(injector, ScreenLayoutData);
    }


    /**
     * Loads the icon for a touch item. The promise returned indicates if the icon was changed on the TouchItem.
     */
    loadIconIfRequired(touchItem: TouchItemData): Promise<boolean> {
        if (touchItem.icon || (touchItem.itemType !== ITEM_TYPE.SELLABLE && touchItem.itemType !== ITEM_TYPE.EXTRA)) {
            return new Promise((resolve) => resolve(false));
        }

        const sellable: SellableReferenceData = this.data.itemsWithImages.find(s => s.sellableId === touchItem.identifier);

        if (sellable || touchItem.iconCheckRequired) {
            touchItem.iconCheckRequired = false;
            return new Promise((resolve) => {
                this.sellableIconService.getEntity(touchItem.identifier).then((data: any) => {
                    touchItem.icon = data.icon;
                    resolve(true);
                }).catch(() => {
                    console.log("Failed to load icon for sellable " + touchItem.identifier);
                    resolve(false);
                });
            });

        } else {
            return new Promise((resolve) => resolve(false));
        }
    }
}
